import React from "react";

const DetectDevice = () => {
  const [mobile, setMobile] = React.useState(false);
  const [tablet, setTablet] = React.useState(false);
  const [desktop, setDesktop] = React.useState(false);

  React.useEffect(() => {
    if (window.innerWidth < 768) {
      setMobile(true);
      setTablet(false);
      setDesktop(false);
    } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
      setMobile(false);
      setTablet(true);
      setDesktop(false);
    } else if (window.innerWidth >= 992) {
      setMobile(false);
      setTablet(false);
      setDesktop(true);
    }
  }, []);

  return {mobile, tablet, desktop};
}

export default DetectDevice;